import { createStore } from 'vuex'
import Axios from './axios';

export default createStore({
  state() {
    return {
      tripfinderViewModel: undefined,
      tripfinderResult: false,
      tripfinderSelectedFilters: []
    }
  },
  mutations: {
    TRIPFINDERVIEWMODEL(state, value) {
      state.tripfinderViewModel = value;
    },
    SET_TRIPFINDERRESULT(state) {
      state.tripfinderResult = true;
    },
    RESET_TRIPFINDER_PAGING(state) {
      state.tripfinderViewModel.paging.items.forEach(item => {
        item.pageNumber = 1;
      });
    },
    SET_INITIAL_RESULT(state) {
      state.tripfinderViewModel.paging.items.forEach(item => {
        item.initial = true;
      });
    }
  },
  getters: {
    pageId: state => {
      return document.body.dataset.pageId;
    },
    singlePlural: (state) => (pageItem) => {
      if (pageItem.documentType === "PageTravel")
        return pageItem.totalNumberOfResults === 1 ? "rejse" : "rejser";

      if (pageItem.documentType === "PageHotel")
        return pageItem.totalNumberOfResults === 1 ? "hotel" : "hoteller";

      if (pageItem.documentType === "PageExperience")
        return pageItem.totalNumberOfResults === 1 ? "oplevelse" : "oplevelser";

      if (pageItem.documentType === "PageCruise")
        return pageItem.totalNumberOfResults === 1
          ? "krydstogt"
          : "krydstogter";
    },
  },
  actions: {
    getBlogListFilter: ({ commit, dispatch, state, getters }, tags) => {
      var params = getters.pageId;
      if(tags && tags != null)
      {
        tags.forEach(tag => params = params +"&tag=" + tag)
      }

      return new Promise(resolve => {
        Axios
          .get('/BlogFinder/filter?id=' + params)
          .then(result => {
            resolve(result);
          });
      });
    },
    searchBlogList: ({ commit, dispatch, state, getters }, data) => {
      return new Promise(resolve => {
        Axios
          .post('/BlogFinder/search', data, {})
          .then(result => {
            resolve(result);
          });
      });
    },
    getPersonListFilter: ({ commit, dispatch, state, getters }, tags) => {
      var params = getters.pageId;
      if(tags && tags != null)
      {
        tags.forEach(tag => params = params +"&persontag=" + tag)
      }

      return new Promise(resolve => {
        Axios.get('/PersonFinder/filter?id=' + params).then(result => {
          resolve(result);
        });
      });
    },
    searchPersonList: ({ commit, dispatch, state, getters }, data) => {
      return new Promise(resolve => {
        Axios
          .post('/PersonFinder/search', data, {})
          .then(result => {
            resolve(result);
          });
      });
    },
    getTripfinderFilter: ({ commit, dispatch, state, getters }, id) => {
      return new Promise(resolve => {
        Axios.get('/Tripfinder/filter?id=' + id).then(result => {
          commit('TRIPFINDERVIEWMODEL', result);
          if(state.tripfinderViewModel.showResultOnPage && !state.tripfinderViewModel.filter.preFilters.length  )
          {
              dispatch('searchTripfinderList');
          }
          resolve();
        });
      });
    },
    searchTripfinderList: ({ commit, dispatch, state, getters }, addToPageIndex) => {
      if (typeof addToPageIndex === 'undefined')
        commit('RESET_TRIPFINDER_PAGING');

      return new Promise(resolve => {
        Axios
          .post('/Tripfinder/search', state.tripfinderViewModel, {})
          .then(data => {
            if (typeof addToPageIndex !== 'undefined') {
              if (data.paging.items.length === 1 && data.paging.items[addToPageIndex].showListView) { // if true, we are adding to cruise list
                data.result.items[addToPageIndex].itemsListView.forEach(item => {
                  state.tripfinderViewModel.result.items[addToPageIndex].itemsListView.push(item);
                });
              } else {
                data.result.items[addToPageIndex].items.forEach(item => {
                  state.tripfinderViewModel.result.items[addToPageIndex].items.push(item);
                });
              }
            } else {
              commit('TRIPFINDERVIEWMODEL', data);
              commit('SET_TRIPFINDERRESULT');
              dispatch("updateTripfinderUrl");
              if(!state.tripfinderViewModel.showAllResults)
                commit('SET_INITIAL_RESULT');
            }
            resolve();
          });
      });
    },
    updateTripfinderUrl: ({ commit, dispatch, state, getters }) => {
      dispatch("getFacetsFromTripfinderSelectedFilters").then((urlParams) => {
        if (urlParams !== "#") {
          history.replaceState(null, "", urlParams);
        }
        else {
          history.replaceState(null, "", location.pathname + "#");
        }
      });
    },
    getFacetsFromTripfinderSelectedFilters: ({ commit, dispatch, state, getters }, id) => {
      let params = new URLSearchParams();
      state.tripfinderSelectedFilters.forEach((filter) =>
        params.append("facet", filter.id)
      );
      return decodeURI(params) ? "#?" + decodeURI(params) : "#";
    },
    selectItem: ({ commit, dispatch, state, getters }, id) => {
      for (let filter of state.tripfinderViewModel.filter.filters) {
        if (loopFilterTagsChildrenAndSelectItem(filter.tags, false)) {
          // Tag found
          break;
        }
      }
      function loopFilterTagsChildrenAndSelectItem(tags, found) {
        for (let tag of tags) {
          if (tag.id === id) {
            tag.isSelected = !tag.isSelected;
            found = true;
            if (tag.isSelected) {
              state.tripfinderSelectedFilters.push(tag);
            }
            else {
              state.tripfinderSelectedFilters = state.tripfinderSelectedFilters.filter(
                (filterTag) => filterTag.id !== tag.id
              );
              dispatch('deselectAllChildren', tag.children)
            }
            if (state.tripfinderResult) {
              dispatch('searchTripfinderList');
            }
          } else if (tag.children) {
            // Not selected
            found = found || loopFilterTagsChildrenAndSelectItem(tag.children);
          }
          if(found)
            break;
        }
        return found;
      }
    },
    deselectAllChildren: ({ commit, dispatch, state, getters }, childrenTags) => {
      if(childrenTags) {
        childrenTags.forEach(childTag => {
          childTag.isSelected = false;
          state.tripfinderSelectedFilters = state.tripfinderSelectedFilters.filter(
            (filterTag) => filterTag.id !== childTag.id
          );
          dispatch('deselectAllChildren', childTag.children);
        });
      }
    },
    showTripfinderResults: ({ commit, dispatch, state, getters }, data) => {
      if (state.tripfinderViewModel.showResultOnPageUrl === "") {
        dispatch('searchTripfinderList');
      } else {
        dispatch("getFacetsFromTripfinderSelectedFilters").then((urlParams) => {
          window.location.href =
            state.tripfinderViewModel.showResultOnPageUrl + urlParams;
        });
      }
    },
    getUrlFacets: function () {
      return new URLSearchParams(decodeURI(window.location.hash.split("?")[1]));
    },
    getMoreResultItems: ({ commit, dispatch, state, getters }, index) => {
      if (state.tripfinderViewModel.paging.items[index].initial) {
        state.tripfinderViewModel.paging.items[index].initial = false;
      } else {
        state.tripfinderViewModel.paging.items[index].pageNumber += 1;
        dispatch("searchTripfinderList", index);
      }
    }
  },
  modules: {
  }
})
